<div class="chart" *ngIf="chart" [chart]="chart"></div>
<blockquote *ngIf="noActivities">
  Non hai attività in questo mese.
</blockquote>
